module.exports = __webpack_public_path__ + "static/img/tianjian6.0bba9c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/tianjian6.png
// module id = GxQz
// module chunks = 19